import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BkButtonDirective } from './bk-button/bk-button.directive';
import { BkInputDirective } from './bk-input/bk-input.directive';
import { BkScrollShadowDirective } from './bk-scroll-shadow/bk-scroll-shadow.directive';
import { BkPillBadgeComponent } from './bk-pill-badge/bk-pill-badge.component';
import { BkCardComponent } from './bk-card/bk-card.component';
import { BkModalComponent } from './bk-modal/bk-modal.component';
import { BkSegmentedControlComponent } from './bk-segmented-control/bk-segmented-control.component';
import { BkEmptyStateComponent } from './bk-empty-state/bk-empty-state.component';
import { TrimSearchDirective } from 'app/_directives/trim-search.directive';
import { TrimInputDirective } from 'app/_directives/trim-input.directive';

const DS_EXPORTS = [BkButtonDirective, BkInputDirective, BkScrollShadowDirective, BkPillBadgeComponent, BkCardComponent, BkModalComponent, BkSegmentedControlComponent, BkEmptyStateComponent, TrimSearchDirective, TrimInputDirective];

@NgModule({
  declarations: [...DS_EXPORTS],
  imports: [CommonModule],
  exports: [...DS_EXPORTS],
})
export class DesignSystemModule {}
